(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[17146,65250],{

/***/ 17146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ BestBabyFormulaLawyersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
;// CONCATENATED MODULE: ./src/components/bestbabyformulalawyers/logo/index.tsx


function BestZantaclawyersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "179",
        height: "46",
        fill: "none",
        viewBox: "0 0 179 46",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_6_190)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#356E3F",
                        d: "M45.57 7.79h5c2.92 0 5.28.73 5.28 3.48a3.299 3.299 0 01-1.76 3v.09a3.19 3.19 0 012.41 3.26c0 2.88-2.49 4.13-5.5 4.13h-5.43V7.79zm4.94 5.45c1.2 0 1.76-.55 1.76-1.41 0-.86-.56-1.21-1.76-1.21h-1.25v2.62h1.25zm.25 5.67c1.46 0 2.15-.51 2.15-1.54s-.69-1.42-2.15-1.42h-1.5v3l1.5-.04zM57.8 16.36a5.32 5.32 0 015.15-5.63c3.18 0 4.68 2.32 4.68 5.2 0 .52-.05 1.04-.15 1.55h-6.12a2.26 2.26 0 002.49 1.71 4.39 4.39 0 002.19-.64l1.2 2.19a7.26 7.26 0 01-3.91 1.24 5.269 5.269 0 01-5.53-5.62zm6.69-1.29a1.35 1.35 0 00-1.46-1.55 1.7 1.7 0 00-1.71 1.55h3.17zM68.78 20.5l1.64-2.28a4.5 4.5 0 002.61 1.08c.78 0 1.08-.22 1.08-.65 0-.43-1-.81-2.06-1.24-1.25-.5-2.71-1.42-2.71-3.18 0-2.1 1.72-3.48 4.25-3.48a6.34 6.34 0 014 1.42l-1.68 2.19a4 4 0 00-2.19-.9c-.62 0-.94.17-.94.6 0 .43.94.77 2 1.16 1.28.47 2.74 1.29 2.74 3.22 0 1.93-1.59 3.56-4.59 3.56a7.18 7.18 0 01-4.15-1.5zM79.39 17.62v-3.73h-1.42v-2.75l1.63-.13.43-2.79h3.05v2.79h2.49v2.88h-2.45v3.67c0 1.18.6 1.57 1.29 1.57.32-.01.637-.068.94-.17l.56 2.66a8.192 8.192 0 01-2.53.38c-2.81 0-3.99-1.76-3.99-4.38zM92.09 7.79h5.11c3.05 0 5.67 1.12 5.67 4.64 0 3.52-2.66 4.93-5.58 4.93h-1.5v4.43h-3.7v-14zm5 6.61c1.46 0 2.14-.73 2.14-2s-.81-1.72-2.23-1.72h-1.24v3.68l1.33.04zM103.77 18.7c0-2.24 1.72-3.48 5.84-3.91-.09-.77-.56-1.12-1.51-1.12a5.78 5.78 0 00-2.7.91l-1.29-2.41a9.061 9.061 0 014.72-1.42c2.8 0 4.47 1.51 4.47 5v6h-3l-.25-1h-.09a4.32 4.32 0 01-3 1.29 3.151 3.151 0 01-3.19-3.34zm5.84-.26v-1.46c-1.76.26-2.32.82-2.32 1.42s.34.77 1 .77a1.69 1.69 0 001.28-.73h.04zM115.7 11.01h3l.25 1.85h.09a3.607 3.607 0 013-2.11c.454-.023.908.052 1.33.22l-.6 3.18a4.877 4.877 0 00-1.2-.18 2.483 2.483 0 00-2.24 1.81v6h-3.69l.06-10.77zM123.57 18.7c0-2.24 1.72-3.48 5.84-3.91-.09-.77-.56-1.12-1.5-1.12a5.78 5.78 0 00-2.71.91l-1.29-2.41a9.09 9.09 0 014.73-1.42c2.79 0 4.46 1.51 4.46 5v6h-3l-.26-1h-.09a4.32 4.32 0 01-3 1.29 3.145 3.145 0 01-2.317-.978 3.165 3.165 0 01-.678-1.091 3.16 3.16 0 01-.185-1.271zm5.84-.26v-1.46c-1.76.26-2.32.82-2.32 1.42s.34.77 1 .77a1.691 1.691 0 001.35-.73h-.03zM141.8 22.45l.13-1.52a3.752 3.752 0 01-2.49 1.07c-2.66 0-4.38-2.14-4.38-5.62s2.19-5.63 4.38-5.63a3.405 3.405 0 012.79 1.33h.09l.3-1.07h2.87v14.51h-3.69v-3.07zm0-4.23v-4a2.21 2.21 0 00-1.46-.51c-.77 0-1.5.69-1.5 2.58 0 1.89.6 2.66 1.59 2.66a1.459 1.459 0 001.37-.73zM147.89 17.62v-6.61h3.68v6.14c0 1.38.34 1.72 1.07 1.72a1.699 1.699 0 001.55-1v-6.86h3.69v10.74h-3l-.24-1.39h-.07a4.066 4.066 0 01-3.31 1.67c-2.38-.03-3.37-1.74-3.37-4.41zM159.96 18.7c0-2.24 1.71-3.48 5.84-3.91-.09-.77-.56-1.12-1.51-1.12a5.75 5.75 0 00-2.7.91l-1.29-2.41a9.061 9.061 0 014.72-1.42c2.79 0 4.47 1.51 4.47 5v6h-3l-.25-1h-.09a4.32 4.32 0 01-3 1.29 3.151 3.151 0 01-3.19-3.34zm5.84-.26v-1.46c-1.76.26-2.32.82-2.32 1.42s.34.77 1 .77a1.7 1.7 0 001.32-.73zM171.93 17.62v-3.73h-1.36v-2.75l1.63-.13.43-2.79h3.05v2.79h2.44v2.88h-2.44v3.67c0 1.18.6 1.57 1.28 1.57.34-.005.677-.062 1-.17l.56 2.66a8.265 8.265 0 01-2.54.38c-2.89 0-4.05-1.76-4.05-4.38zM45.57 27.21h3.69v10.86h5.28v3.1h-9l.03-13.96zM56.16 38.12c0-2.24 1.72-3.48 5.84-3.91-.08-.77-.55-1.12-1.5-1.12a5.75 5.75 0 00-2.7.91l-1.29-2.41a9.06 9.06 0 014.72-1.42c2.79 0 4.47 1.51 4.47 5v6h-3l-.26-1h-.08a4.38 4.38 0 01-3 1.28 3.16 3.16 0 01-3.2-3.33zm5.84-.26v-1.5c-1.76.26-2.32.82-2.32 1.42s.35.77 1 .77a1.681 1.681 0 001.32-.69zM67.37 30.43h3.65l.81 4.51c.17 1.07.26 2.15.43 3.26h.09c.17-1.11.34-2.23.6-3.26l1-4.51h3.13l1 4.51c.26 1.07.43 2.15.65 3.26h.08c.17-1.11.26-2.19.43-3.26l.82-4.51h3.39L81 41.17h-4.29l-.78-3.74c-.17-1-.34-2-.51-3.16h-.09c-.17 1.19-.3 2.17-.47 3.16l-.73 3.74h-4.21l-2.55-10.74zM85.18 44.99l.65-2.79c.222.064.45.108.68.13a1.55 1.55 0 001.68-1.08l.13-.47-4.08-10.35h3.69l1.29 4.12c.3 1 .51 2 .77 3h.09c.21-1 .43-2 .68-3l1.08-4.12h3.52l-3.61 10.56c-1.12 2.9-2.28 4.21-4.94 4.21-.55.012-1.1-.06-1.63-.21zM96.08 35.8a5.32 5.32 0 015.16-5.63c3.17 0 4.68 2.32 4.68 5.2 0 .517-.05 1.033-.15 1.54h-6.12a2.26 2.26 0 002.49 1.72 4.39 4.39 0 002.19-.64l1.2 2.19a7.261 7.261 0 01-3.91 1.24 5.27 5.27 0 01-5.54-5.62zm6.7-1.29a1.36 1.36 0 00-1.46-1.55 1.7 1.7 0 00-1.75 1.55h3.21zM107.93 30.43h3l.26 1.85h.08a3.62 3.62 0 013.05-2.11 3.16 3.16 0 011.33.22l-.6 3.18a4.877 4.877 0 00-1.2-.18 2.483 2.483 0 00-2.24 1.81v6h-3.69l.01-10.77zM115.83 39.92l1.63-2.27a4.67 4.67 0 002.62 1.07c.77 0 1.07-.22 1.07-.65 0-.43-1-.81-2.06-1.24-1.24-.49-2.7-1.42-2.7-3.18 0-2.1 1.72-3.48 4.25-3.48a6.36 6.36 0 013.93 1.42l-1.63 2.19a3.999 3.999 0 00-2.19-.9c-.62 0-.95.17-.95.6 0 .43.95.77 2 1.16 1.29.47 2.75 1.29 2.75 3.22 0 1.93-1.59 3.56-4.6 3.56a7.17 7.17 0 01-4.12-1.5zM34.65 13.36c.42.93.88 1.85 1.27 2.79 1.15 2.83 2.26 5.66 3.4 8.49.12.278.257.548.41.81.19.34 0 .65-.34.65h-9.7c-.36 0-.51-.25-.36-.58.42-1 .87-1.91 1.28-2.87a1541.41 1541.41 0 003.7-8.87c.06-.14.13-.27.2-.4l.14-.02zm-.43 2.32h-.17l-3.89 9.68h3.68c.36 0 .42-.13.42-.44v-8.86c-.01-.09-.03-.23-.04-.38zm.8-.07h-.11v9.75h4l-3.89-9.75zM39.71 26.36a5.6 5.6 0 01-5.2 3.41 5.5 5.5 0 01-5.11-3.41h10.31zM5.38 13.36c.42.93.88 1.85 1.26 2.79 1.15 2.83 2.27 5.66 3.41 8.49.116.28.253.55.41.81.19.34 0 .65-.35.65H.42c-.36 0-.51-.25-.37-.58.43-1 .88-1.91 1.28-2.87 1.25-3 2.47-5.91 3.71-8.87.06-.14.13-.27.19-.4l.15-.02zm-.43 2.32h-.17c-1.29 3.23-2.59 6.46-3.9 9.73h3.69c.36 0 .41-.13.41-.44v-8.86c0-.14-.02-.28-.03-.43zm.8-.07h-.11v9.75h4l-3.89-9.75zM10.44 26.36a5.61 5.61 0 01-5.2 3.41 5.49 5.49 0 01-5.11-3.41h10.31zM19.82 7.94a3.97 3.97 0 100-7.94 3.97 3.97 0 000 7.94z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_6_190)",
                        d: "M34.57 12.58c-3.38-6.42-10.3-6.24-14.65-1.52-3.85 3.95-7.11 9.14-7.73 14.72a.721.721 0 000 .23 19.659 19.659 0 006.07 16c1.92 1.89 1.43 1.86 3.33 0 .43-.43.89-.85 1.28-1.32a19.759 19.759 0 004.48-16.13 20.39 20.39 0 00-4.82-9.8 17.26 17.26 0 00-2.4 2.91 20 20 0 013.38 10.18 18 18 0 01-2.73 10.35l-.9-15.26-.94 15a18.73 18.73 0 01-2.61-12 19.63 19.63 0 014.47-10c2.23-2.7 5.16-5.16 8.86-5.07a8.57 8.57 0 012.6.46c.51.23 1.99.68 2.31 1.25z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint1_linear_6_190)",
                        d: "M19.35 10.77c-4.34-4.71-10.39-4-14.49 1.52a8.67 8.67 0 0111.85 1.54l2.64-3.06z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        fill: "url(#paint2_linear_6_190)",
                        d: "M19.35 10.77c-4.34-4.71-10.39-4-14.49 1.52a8.67 8.67 0 0111.85 1.54l2.64-3.06z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M23.94 12.78l.08-.06-.08.06z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        style: {
                            mixBlendMode: "multiply"
                        },
                        fill: "url(#paint3_linear_6_190)",
                        d: "M12.16 25.78a.721.721 0 000 .23 19.66 19.66 0 006.07 16c1.92 1.89 1.43 1.86 3.33 0 .43-.43.89-.85 1.28-1.32a19.76 19.76 0 004.48-16.13 20.39 20.39 0 00-4.82-9.8 17.26 17.26 0 00-2.4 2.91 20 20 0 013.38 10.18 18 18 0 01-2.73 10.35l-.9-15.26-.94 15a18.73 18.73 0 01-2.61-12"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_6_190",
                        x1: "12.05",
                        x2: "34.54",
                        y1: "25.52",
                        y2: "25.52",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#78AB51"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#00A259"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_6_190",
                        x1: "4.86",
                        x2: "19.35",
                        y1: "10.73",
                        y2: "10.73",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.05",
                                stopColor: "#356E3F"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#356E3F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_6_190",
                        x1: "12.58",
                        x2: "25.57",
                        y1: "11.36",
                        y2: "17.79",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#221F20"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_6_190",
                        x1: "17.21",
                        x2: "19.56",
                        y1: "7.7",
                        y2: "25.81",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.24",
                                stopColor: "#221F20"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#fff",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_6_190",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H178.42V45.2H0z"
                        })
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/styles/variables/bestbabyformulalawyersVariables.module.scss
var bestbabyformulalawyersVariables_module = __webpack_require__(66);
var bestbabyformulalawyersVariables_module_default = /*#__PURE__*/__webpack_require__.n(bestbabyformulalawyersVariables_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/bestbabyformulalawyersWrapper.tsx










const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
function BestBabyFormulaLawyersWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { visitDetails: { region  } ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "BabyFormula",
                    domain: "BestBabyFormulaLawyers.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "BabyFormula",
                    domain: "BestBabyFormulaLawyers.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        iconColor: (bestbabyformulalawyersVariables_module_default()).purpleDark,
                        slogan: `find the best baby formula lawyers ${region ? `in ${region}` : ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BestZantaclawyersLogo, {})
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 66:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"purpleLight":"#f6f1ff","purpleDark":"#674998"};

/***/ })

}]);